let introMovie = promokit.video({
  el: '#player-intro',
  url: 'https://vod.plaync.com/lineage/remaster/main_intro.mp4',
  controls: false,
  autoplay: false,
  loop: false,
  mute: true,
  preload: true
});
let loopMovie = promokit.video({
  el: '#player-intro-loop',
  url: 'https://vod.plaync.com/lineage/remaster/main_loop.mp4',
  controls: false,
  autoplay: false,
  loop: true,
  mute: true,
  preload: true
});
let introSequence = promokit.sequence({
  el: '#titleIntro',
  // path: _path + 'img/sequence/intro',
  path: promokit.store('staticPath') + '/promo/lineage/event/2020/200520_episode1/img/sequence/intro',
  prefix: 'title_intro_',
  fps: 30,
  frame: 121,
  autoplay: false,
  loop: false,
  preload: true
});
let loopSequence = promokit.sequence({
  el: '#titleLoop',
  // path: _path + 'img/sequence/loop',
  path: promokit.store('staticPath') + '/promo/lineage/event/2020/200520_episode1/img/sequence/loop',
  prefix: 'title_loop_',
  fps: 30,
  frame: 120,
  autoplay: false,
  loop: true,
  preload: true
});

var Episode = (function() {

  var introChk = false;
  var intro = new TimelineMax({paused: true}),
      clan = new TimelineMax({paused: true}),
      episode1 = new TimelineMax({paused: true});
  var _path = '';
  var _staticPath = {
    local: '200520_episode1/',
    op: 'https://op-wstatic.ncsoft.com',
    rc: 'https://rc-wstatic.plaync.co.kr',
    live: 'https://wstatic-cdn.plaync.com'
  };

  function Person(opts) {
    this.opts = opts;
    this.selector = {
      box: '[data-scene]'
    };
    this.state = {
      y: [],
      introTimer: null,
      resizeTimer: null,
      isScrolling: false,
      rsp: false
    };
    this.scenebox = {};
    this.movie = {};
    this.sequence = {};
    this.layer = {};
    this.slider = {};
    this.init();
  }

  Person.prototype = {
    init: function() {
      var context = this;
      this.state.length = $(this.selector.box).length - 1;

      this.staticPath();
      this.setMovie();
      this.setSequence();
      this.setSlide();
      this.mouseWheel();
      this.resize();
      this.sceneSettings();
      this.controls();

      context.layout();
      context.sceneAnimation();
      context.state.isScrolling = true;

      context.movie.introMovie.play();
      setTimeout(function() {
        context.sequence.intro.play();
        intro.seek(0);
        intro.play();
        context.remote(0);
      }, 100);
      context.movie.introMovie.on('ended', function() {
        context.movie.loopMovie.seek(0);
        context.movie.loopMovie.play();
        $(window).trigger('resize');
        $('.loop').css('visibility', 'visible');
        TweenMax.to($('#player-intro'), 0, {
          delay: 0.1,
          opacity: 0,
          onComplete: function() {
            $('#player-intro').addClass('hide');
            introChk = true;
          }
        });
        context.state.isScrolling = false;
      });
      context.sequence.intro.on('end', function() {
        context.sequence.loop.play();
        TweenMax.to($('.intro-tit--init'), 0.8, {
          opacity: 0,
          ease: Power4.easeIn
        });
      });

    },
    staticPath: function() {
      var loc = location.href;
      var projectPath = '/promo/lineage/history/2020/200513_episode1/';
      _path = _staticPath.live + projectPath;

      if (/rc\./i.test(loc)) {
        _path = _staticPath.rc + projectPath;
      }
      if (/op\./i.test(loc)) {
        _path = _staticPath.op + projectPath;
      }
      if (/local\.|localhost|opdev\.|ui-static\.|file:/i.test(loc)) {
        _path = _staticPath.local;
      }
    },
    remote: function(target) {
      var $menu = $('#menu');
      var $bullet = $menu.find('a');
      if (target == 0) {
        $bullet.removeClass('on');
      }
      else {
        $bullet.removeClass('on').eq(target - 1).addClass('on');
      }
      $menu.removeClass().addClass('active-' + target);
    },
    resize: function() {
      var context = this;
      $(window).resize(function() {
        sh = $(window).height();
        if (context.state.resizeTimer) {
          clearTimeout(context.state.resizeTimer);
        }
        context.state.resizeTimer = setTimeout(function() {
          context.state.resizeTimer = null;
          context.layout();
        }, 100);
      }).resize();
    },
    mouseWheel: function() {
      var context = this;
      $(this.opts.el).on('mousewheel DOMMouseScroll', function(e) {
        context.wheelDelta(e);
      });
    },
    getwheelDelta: function(e) {
      if (e.type == 'DOMMouseScroll') return e.originalEvent.detail < 0 ? 1 : -1;
      if (e.originalEvent.wheelDeltaY) return e.originalEvent.wheelDeltaY < 0 ? -1 : 1;
      return e.originalEvent.wheelDelta < 0 ? -1 : 1;
    },
    wheelDelta: function(e) {
      var context = this;
      if (!context.state.isScrolling) {
        context.state.isScrolling = true;
        if (context.getwheelDelta(e) < 0) {
          this.scrollDown();
        }
        else {
          this.scrollUp();
        }
        setTimeout(function() {
          context.state.isScrolling = false;
        }, context.opts.wheelsp);
      }
      return false;
    },
    layout: function() {
      TweenMax.to([$('#container')], 0, {autoAlpha: 1});
      TweenMax.to([$(this.opts.el).find($(this.selector.box))], 0, {autoAlpha: 1, y: '0%'});
      TweenMax.to([$(this.opts.el).find($(this.selector.box).eq(this.opts.idx))], 0, {autoAlpha: 1, y: '0%', zIndex: 10});
    },
    scrollDown: function() {
      if (this.opts.idx < this.state.length) {
        this.opts.before = this.opts.idx;
        this.opts.idx = this.opts.idx + 1;
      }
      else if (this.opts.idx == this.state.length) {
        return false;
      }
      this.moveAnimation();
    },
    scrollUp: function() {
      if (this.opts.idx > 0) {
        this.opts.before = this.opts.idx;
        this.opts.idx = this.opts.idx - 1;
      }
      else if (this.opts.idx == 0) {
        return false;
      }
      this.moveAnimation();
    },
    moveAnimation: function() {

      for (var i = 0; i < this.state.length + 1; i++) {
        if (this.opts.idx == i) {
          if (this.opts.before > this.opts.idx) {
            TweenMax.fromTo([$(this.opts.el).find($(this.selector.box).eq(i))], 0, {zIndex: ''}, {zIndex: 10});
            TweenMax.fromTo([$(this.opts.el).find($(this.selector.box).eq(i))], 1.2, {y: '-100%'}, {y: '0%', ease: Power4.easeInOut});
          }
          else if (this.opts.before < this.opts.idx) {
            TweenMax.fromTo([$(this.opts.el).find($(this.selector.box).eq(i))], 0, {zIndex: ''}, {zIndex: 10});
            TweenMax.fromTo([$(this.opts.el).find($(this.selector.box).eq(i))], 1.2, {y: '100%'}, {y: '0%', ease: Power4.easeInOut});
          }
        }
        else if (this.opts.before == i) {
          TweenMax.to([$(this.opts.el).find($(this.selector.box).eq(i))], 0, {zIndex: 8, y: '0%'});
        }
        else {
          TweenMax.to([$(this.opts.el).find($(this.selector.box).eq(i))], 0, {zIndex: '', y: '0%'});
        }
      }
      this.sceneAnimation();
    },
    sceneSettings: function() {
      intro.addLabel('init')
           .add(function() {
             $('#nav').addClass('active');
           }, 'init+=2.6')
           .add(function() {
             $('#section-footer').fadeIn();
           }, 'init+=3.2')
           .fromTo($('#intro').find('.etc-menu'), 0.7, {y: 40, alpha: 0}, {y: 0, alpha: 1, ease: Power3.easeOut}, 'init+=3.65')
           .fromTo($('.promokit-header-button'), 0.3, {opacity: 0, x: 30}, {opacity: 1, x: 0, delay: 0, ease: Power2.easeOut}, 'init+=3.65');

      clan.addLabel('init')
          .fromTo($('#clan').find('.bg'), 8, {scale: 1.25}, {scale: 1, ease: Power2.easeOut}, 'init');

      episode1.addLabel('init')
              .fromTo($('#episode').find('.bg'), 8, {scale: 1.25}, {scale: 1, ease: Power2.easeOut}, 'init');

    },
    controls: function() {
      var context = this;
      $('#menu > a').on('click', function(e) {
        e.preventDefault();
        var num = $(this).data('anchor');
        if (window.Episode.opts.idx != num) {
          window.Episode.opts.before = window.Episode.opts.idx;
          window.Episode.opts.idx = num;
          window.Episode.moveAnimation();
        }
      });
      $('#menu > a').on('mouseenter', function() {
        $(this).addClass('hover');
      });
      $('#menu > a').on('mouseleave', function() {
        $(this).removeClass('hover');
      });
    },
    sceneAnimation: function() {
      if (this.opts.idx == 0) {
        if (introChk) {
          this.remote(0);
          this.movie.loopMovie.seek(0);
          this.movie.loopMovie.play();
        }
      }
      else if (this.opts.idx == 1) {
        this.remote(1);
        clan.seek(0);
        clan.play();
      }
      else if (this.opts.idx == 2) {
        this.remote(2);
        episode1.seek(0);
        episode1.play();
      }
    },
    setSlide: function() {
      var context = this;
      this.slider.imgslider1 = new Swiper('.swiper-clan', {
        slidesPerView: 3,
        spaceBetween: 50,
        speed: 800,
        pagination: {
          el: '.swiper-pagination--clan',
          type: 'progressbar'
        },
        navigation: {
          nextEl: '.swiper-button--clan-next',
          prevEl: '.swiper-button--clan-prev'
        },
        allowTouchMove: false
      });
      this.slider.imgslider2 = new Swiper('.swiper-episode', {
        slidesPerView: 3,
        spaceBetween: 50,
        speed: 800,
        pagination: {
          el: '.swiper-pagination--episode',
          type: 'progressbar'
        },
        navigation: {
          nextEl: '.swiper-button--episode-next',
          prevEl: '.swiper-button--episode-prev'
        },
        allowTouchMove: false
      });
      $('.swiper-container').each(function() {
        var lngth = $(this).find('.swiper-slide').length;
        if (lngth <= 3) {
          $(this).find('.swiper-control-wrap').hide();
        }
      });
    },
    setMovie: function() {
      this.movie.introMovie = introMovie;
      this.movie.loopMovie = loopMovie;
    },
    setSequence: function() {
      this.sequence.intro = introSequence;
      this.sequence.loop = loopSequence;
    }
  };

  return Person;

})();

//preload

promokit.preload({
  game: 'lineage',
  complete: function() {
    window.Episode = new Episode({
      el: '#scene-box',
      idx: 0,
      before: 0,
      wheelsp: 1200
    });
  }
});



// WEBPACK FOOTER //
// ./src/js/index.js